import { MapMatchQuality } from './mapmatchquality';

export class MapMatchQualityLine extends MapMatchQuality {
  public bbox: string; // "BOX(3.8574 51.2476,4.0658 51.3178)"
  public osmids: number[] = [];

  static copy(mmql: MapMatchQualityLine): MapMatchQualityLine {
    const osmids: number[] = [];
    for (let i = 0; i < mmql.osmids.length; i++) {
      osmids[i] = mmql.osmids[i];
    }

    return {
      vildLocNr: mmql.vildLocNr,
      vildVersionId: mmql.vildVersionId,
      quality: mmql.quality,
      bbox: `${mmql.bbox}`,
      osmids
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/models/mapmatchqualityline.model.ts